import React from 'react';
import { SvgIcon } from 'material-ui';

const SwitchIcon = props => (
  <SvgIcon {...props} viewBox='0 0 19 19' style={{ height: 19, width: 19 }}>
    <g
      id='4'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
      transform='translate(-300.000000, -482.000000)'
      strokeLinecap='square'
    >
      <g id='plus' transform='translate(301.000000, 483.000000)' stroke='#979797' strokeWidth='2'>
        <path d='M0.791666667,8.5 L18.2083333,8.5' id='Line-3-Copy' />
        <path d='M9,0 L9,17' id='Line-3-Copy-6' />
      </g>
    </g>
  </SvgIcon>
);

export default SwitchIcon;



// WEBPACK FOOTER //
// ./src/icons/PlusIcon.js